import { useScrollAnimation, useCountUp } from "../../../hooks/useScrollAnimation";
import { stats } from "../../../mocks/homeData";

function StatItem({
  value,
  suffix,
  label,
  isVisible,
  delay,
}: {
  value: number;
  suffix: string;
  label: string;
  isVisible: boolean;
  delay: number;
}) {
  const count = useCountUp(value, 2000, isVisible);

  return (
    <div
      className={`text-center ${isVisible ? "animate-fade-up" : "opacity-0"}`}
      style={{ animationDelay: `${delay}s` }}
    >
      <div className="font-heading font-extrabold text-4xl sm:text-5xl md:text-6xl text-copper mb-2 md:mb-3">
        {count}
        <span className="text-copper-light">{suffix}</span>
      </div>
      <p className="font-body text-sm md:text-base text-white/70">{label}</p>
    </div>
  );
}

export default function Stats() {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section
      id="stats"
      className="relative bg-navy py-16 md:py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5">
        <div
          className="w-full h-full"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      <div
        ref={ref}
        className="relative max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8"
      >
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-0">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`${index < stats.length - 1 ? "lg:border-r lg:border-white/10" : ""} ${
                index < 2 ? "sm:border-b sm:border-white/10 lg:border-b-0 pb-8 sm:pb-8 lg:pb-0" : ""
              }`}
            >
              <StatItem
                value={stat.value}
                suffix={stat.suffix}
                label={stat.label}
                isVisible={isVisible}
                delay={0.1 + index * 0.15}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}